import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';

import ServiceUnavailable from 'App/common/Errors/ServiceUnavailable'; // ← add
import DetailsPage from 'App/DetailsPage/DetailsPage';
import ListPage from 'App/ListPage/ListPage';
import { useAppSelector } from 'store/store'; // ← add

import MaintenancePage from '../App/common/Errors/MaintenancePage';
import { messageExchangeConfig, postMxMessage } from '../utils/message-exchange.utils';
import { DetailRedirect, NoMatchRoute } from './handlers/handlers';

import styles from './../App/App.module.scss';

const AppRoutes: React.FC = () => {
  const [searchParams] = useSearchParams();
  const locationHash = useLocation().hash;

  const { code, errorDescription } = useAppSelector((state) => state.outage);

  if (code === 503) {
    const element = errorDescription ? <MaintenancePage description={errorDescription} /> : <ServiceUnavailable />;

    return (
      <Routes>
        <Route path='*' element={element} />
      </Routes>
    );
  }

  const hashTrackingIds = locationHash.match(/id=([\w\d,]+)/);
  const queryParamIds = searchParams.get('id') || (hashTrackingIds && hashTrackingIds[1]) || '';
  const trackingIdsArray = queryParamIds?.split(/[\s,]+/).filter((trackingId) => trackingId);
  const singleTrackingId = trackingIdsArray?.length === 1 && trackingIdsArray[0];

  if (singleTrackingId) {
    postMxMessage(messageExchangeConfig.queryTrackingId, {});
    return <Navigate to={`/details/${singleTrackingId}`} />;
  }

  return (
    <Routes>
      <Route path='search' element={<ListPage />} />

      <Route
        path='details/:trackingId'
        element={
          <div className={styles.routeContainer}>
            <DetailsPage />
          </div>
        }
      />

      <Route path='article/:trackingId' element={<DetailRedirect />} />
      <Route path='*' element={<NoMatchRoute />} />
    </Routes>
  );
};

export default AppRoutes;
